import PropTypes from 'prop-types';
import DefaultUpgradeNotification from './DefaultUpgradeNotification';
import ExperimentalUpgradeNotification from './ExperimentalUpgradeNotification';

import OptimizelyExperiment from '../optimizely';
import { OPTIMIZELY_AUDIT_TRIAL_EXPERIMENT } from '../data/optimizely';
import PAGE_NAMES from '../data/constants';

const UpgradeNotification = (props) => {
  if (props.id.includes(PAGE_NAMES.PROGRESS)) {
    return (
      <DefaultUpgradeNotification {...props} />
    );
  }

  return (
    <OptimizelyExperiment
      defaultComponent={DefaultUpgradeNotification}
      experimentalComponent={ExperimentalUpgradeNotification}
      defaultVariationKey="off"
      experimentKey={OPTIMIZELY_AUDIT_TRIAL_EXPERIMENT.KEY}
      {...props}
    />
  );
};

UpgradeNotification.propTypes = {
  id: PropTypes.string.isRequired,
};

export default UpgradeNotification;
